import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const StepsHeader = ({ stepText, description }) => {
  return (
    <Container>
      <span style={{ fontSize: 20, marginBottom: 8 }}>{stepText}</span>
      <span style={{ fontSize: 14 }}>{description}</span>
    </Container>
  )
}

export default StepsHeader
